import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { selectEcommerceConfigState } from '../../../store/selectors/ecommerce-config.selectors';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { first, map, takeUntil } from 'rxjs/operators';

import { authUserPhone, sendWebhook } from '../../../store/actions';
import { AppState } from '../../../store/app-reducers';
import { AuthUserPhoneState } from '../../../store/reducers';
import { IDecodeJwt } from '../../models/Tenderos.interface';
import { SharedServiceService } from '../../services/shared-service.service';
import { ToastControllerService } from '../../services/toast-controller.service';
import { UtilitiesService } from '../../services/utilities/utilities.service';

@Component({
  selector: 'app-timeout-edit',
  templateUrl: './timeout-edit.page.html',
  styleUrls: ['./timeout-edit.page.scss'],
})
export class TimeoutEditPage implements OnInit, OnDestroy {

  public nombre: Observable<string>;
  public loading = false;
  public isRenewToken = false;

  private telefono: Observable<string>;
  private decodeToken: IDecodeJwt = {} as IDecodeJwt;
  private waRedirect = {
    phoneChat: '',
    urlRedirect: '',
    targetRedirect: '',
    text: '',
  };
  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private toastS: ToastControllerService
    , private sharedS: SharedServiceService
    , private translate: TranslateService
    , private utilS: UtilitiesService
    , private modalCtrl: ModalController
    , private store: Store<AppState>
    , private nav: NavController
  ) {
    this.telefono = this.store.select(selectEcommerceConfigState).pipe(map(value => value.respConfig.Telefono || ''));
    this.nombre = this.store.select(selectEcommerceConfigState).pipe(map(value => value.respConfig.Responsable || ''));
  }

  async ngOnInit() {
    this.store.dispatch(sendWebhook({ idPedido: 'N/A', evento: 'inactividad_webview', metadata: [] }));
    this.decodeToken = this.utilS.getDecodeTokenJwt(this.sharedS.urlWithTokenWA$.value);
    const waRedirectObj = this.translate.instant('Miscellaneous.wa-redirect');
    this.waRedirect = {
      phoneChat: waRedirectObj['phone-chat'] ? waRedirectObj['phone-chat'] : '',
      urlRedirect: waRedirectObj['url-redirect'] ? waRedirectObj['url-redirect'] : '',
      targetRedirect: waRedirectObj['target-redirect'] ? waRedirectObj['target-redirect'] : '',
      text: waRedirectObj['text-timeout'] ? waRedirectObj['text-timeout'] : '',
    };

    this.store.select('AuthUserPhone')
      .pipe(
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackRenewToken);

    this.sharedS.renewToken$
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(rt => this.isRenewToken = rt);
  }

  ngOnDestroy(): void {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  /**
   * Callback de nuevo token
   */
  private callbackRenewToken = async (resp: AuthUserPhoneState) => {
    this.loading = resp.loading;
    if (resp.success) {
      this.modalCtrl.dismiss(true);
      this.nav.navigateForward(['/Tienda'], { animated: true, animationDirection: 'forward', queryParams: { token: resp.data.token } });
    }

    if (resp.failed) {
      const message: string = this.translate.instant('Labels.error-renew-token');
      await this.toastS.presentToast(message, 'grayDemon', 'alert', 2500, 'toast-network');
    }
  }

  // * Manda a generar nuevo token
  public onReNewToken = async () => {
    const Telefono = await firstValueFrom(this.telefono.pipe(first()));
    this.store.dispatch(authUserPhone({ Telefono }));
  }

  // * Regresar a WA
  public onWA = () => {
    if (this.waRedirect.urlRedirect.length > 0 && this.waRedirect.phoneChat.length > 0) {
      window.open(`${this.waRedirect.urlRedirect}${this.waRedirect.phoneChat}${this.waRedirect.text}`, this.waRedirect.targetRedirect);
      window.close();
      this.modalCtrl.dismiss(false);
    }
  }

}
